<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div
        v-if="role != 'pasien'"
        class="bg-light border-right"
        id="sidebar-wrapper"
      >
        <Sidebar active="Rawat Jalan" />
      </div>
      <div
        :id="
          role != ('pasien' || 'antrian')
            ? 'page-content-wrapper'
            : 'page-content-no-sidebar'
        "
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-2">
              <button
                class="
                  btn btn-outline-primary btn-no-outline btn-with-icon-left
                  mt-3
                  btn-lg
                  px-0
                "
                @click="() => goBack('/ralan')"
              >
                <i class="material-symbols-outlined">arrow_back</i>Kembali
              </button>
            </div>
          </div>

          <center>
            <h2 class="mb-5">Pendaftaran Rawat Jalan</h2>

            <h4 class="font-body text-muted mb-5">
              {{
                role == "pasien"
                  ? "Silakan masukkan nomor rekam medis Anda"
                  : "Silakan scan barcode kartu pasien atau masukkan nomor rekam medis pasien"
              }}
            </h4>
          </center>
          <div class="row">
            <div class="col-md-6 offset-md-3">
              <div class="form-group">
                <div class="input-group input-group-lg">
                  <input
                    ref="focusMe"
                    type="number"
                    :class="
                      'form-control form-control-lg pl-5 with-icon-left without-label ' +
                        (isError ? 'error' : '')
                    "
                    placeholder="Nomor rekam medis"
                    v-model="no_rm"
                    v-on:keyup.enter="() => search(String(no_rm))"
                  />
                  <i class="material-symbols-outlined">assignment_ind</i>
                  <div class="input-group-append">
                    <button
                      class="btn btn-secondary btn-with-icon-right"
                      @click="() => search(String(no_rm))"
                    >
                      SELANJUTNYA
                      <i class="material-symbols-outlined">chevron_right</i>
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-if="isError"
                class="card card-alert card-alert-danger mb-5"
              >
                <i class="material-symbols-outlined alert-icon"
                  >report_problem</i
                >
                <div class="alert-content">
                  <h4 class="alert-title">Data Pasien Tidak Ditemukan</h4>
                  <p class="alert-desc">
                    Tidak ditemukan data pasien yang sesuai dengan nomor rekam
                    medis yang Anda masukkan. Periksa kembali nomor rekam medis
                    pasien yang Anda masukkan.
                  </p>
                </div>
                <!--a-- id="closeAlert" class="alert-close">
                            <i class="material-symbols-outlined">close</i>
                        </!--a-->
              </div>
              <div v-if="searchResult" class="card px-3 py-2">
                <div class="user-item">
                  <div class="user-avatar user-avatar-lg">
                    <img :src="searchResult.foto || '/img/user.jpg'" />
                    <div class="user-info">
                      <h4 class="user-name">{{ searchResult.nama }}</h4>
                    </div>
                  </div>
                  <span class="badge badge-success">
                    No RM : {{ searchResult.no_rm }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
// import { HTTP } from "@/config.js";
let patients = [
  {
    nama: "Ahmad Subekti",
    foto: "",
    no_rm: "12345",
  },
];
let searchResult = null;
export default {
  name: "Dashboard",
  components: {
    Navbar,
    Sidebar,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      no_rm: null,
      patients: patients,
      isError: false,
      searchResult: searchResult,
      role: "",
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    displayResult(result) {
      this.isError = false;
      this.searchResult = result;
      //console.log(result);
      setTimeout(() => {
        this.$router.push(`/ralan/form/${result.no_rm}`);
      }, 1000);
    },
    displayNotFoundError() {
      this.isError = true;
      //console.log("error not found");
      setTimeout(() => {
        this.isError = false;
      }, 5000);
    },
    async search(no_rm) {
      searchResult = null;
      try {
        let result = await this.$store.state.HTTP.get(`pasien/cari/${no_rm}`);
        //console.log(result);
        if (result.status == "200") {
          //console.log(result.data);
          this.displayResult(result.data);
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
        this.displayNotFoundError();
        // this.errors.push(e);
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.role = this.$store.state.role;
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
  },
};
</script>
